<template>
  <div class="verification bg-white h-screen w-full">
    <div class="bg-neutral-600 pt-24">
      <div class="flex justify-center items-center">
        <img src="@/assets/images/logos/logo-white.png" class="inline-block" />
      </div>
      <div class="svg -bottom-8 relative z-1">
        <svg width="1920" :height="isMobile ? 100 : 293" class="max-w-full" preserveAspectRatio="xMinYMin meet" viewBox="0 0 1920 293" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.2"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 60.3466L80 68.8829C160 77.4192 320 94.4918 480 111.564C640 128.637 800 145.71 960 124.369C1120 103.028 1280 43.2741 1440 17.6652C1600 -7.94373 1760 0.592564 1840 4.86071L1920 9.12886V214H1840C1760 214 1600 214 1440 214C1280 214 1120 214 960 214C800 214 640 214 480 214C320 214 160 214 80 214H0V60.3466Z"
            fill="#101840"
          />
          <path
            opacity="0.3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1920 60.3466L1840 68.8829C1760 77.4192 1600 94.4918 1440 111.564C1280 128.637 1120 145.71 960 124.369C800 103.028 640 43.2741 480 17.6652C320 -7.94373 160 0.592564 80 4.86071L0 9.12886V214H80C160 214 320 214 480 214C640 214 800 214 960 214C1120 214 1280 214 1440 214C1600 214 1760 214 1840 214H1920V60.3466Z"
            fill="#101840"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M556.501 167.845C591.197 173.772 625.901 179.7 695.328 179.7C764.671 179.7 799.361 173.78 834.037 167.862C866.176 162.378 898.302 156.895 957.997 156.13V156.13C957.998 156.13 957.999 156.13 958 156.13C958.001 156.13 958.002 156.13 958.003 156.13V156.13C1017.7 156.895 1049.82 162.378 1081.96 167.862C1116.64 173.78 1151.33 179.7 1220.67 179.7C1290.1 179.7 1324.8 173.772 1359.5 167.845C1394.18 161.922 1428.84 156 1498.16 156C1567.5 156 1602.21 161.926 1636.91 167.851C1671.61 173.776 1706.3 179.7 1775.61 179.7C1845.05 179.7 1879.77 173.765 1914.48 167.832C1916.32 167.518 1918.16 167.203 1920 166.89V292.13H958.003H957.997H-4V166.89C-2.15628 167.203 -0.317699 167.518 1.5209 167.832C36.2324 173.765 70.9513 179.7 140.391 179.7C209.701 179.7 244.395 173.776 279.091 167.851C313.793 161.926 348.497 156 417.838 156C487.156 156 521.824 161.922 556.501 167.845Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="form absolute left-1/2 top-1/2 flex flex-col justify-center items-center transform -translate-x-1/2 -translate-y-1/2 z-10 rounded-md bg-white shadow-soft py-16 px-56">
        <img src="@/assets/images/error.png" class="inline-block" />
        <p class="my-5 font-bold text-4xl">Verifikasi Gagal</p>
        <p class="mb-4">Link sudah tidak valid atau kadaluarsa</p>
        <Button @action="doResend()" buttonText="Verifikasi Ulang" size="regular" type="secondary" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  components: {
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button')
  },
  computed: {
    ...mapGetters('common', ['isMobile'])
  },
  methods: {
    doResend() {}
  }
}
</script>
